import { useContext } from "react";
import UserAuthenticationActionsContext from "~/contexts/UserAuthenticationActionsContext";

export default function useUserAuthenticationActions() {
  return useContext(UserAuthenticationActionsContext);
}
